export function isIapDebugEnabled() {
  return false;
}
export function logIapDebug() {}
export function formatCreditPriceComparisonLines() {
  return [];
}
export async function collectIapRuntimeReport() {
  return { stub: true };
}
export function getIapSettingsSnapshot() {
  return { stub: true };
}
export function printIapSettings() {}
export async function printIapRuntimeReport() {
  return { stub: true };
}
